<template>
    <BreadCrumb PageTitle="Faire une régulation" />
    <Paiement />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import Paiement from "../../components/Paiement/PaiementRegulation.vue";
    export default defineComponent({
      name: "PaiementRegularisationPage",
      components: {
        BreadCrumb,
        Paiement,
      },
    });
  </script>